import { render, staticRenderFns } from "./FlowConfig01List.vue?vue&type=template&id=6bd366a7&scoped=true&"
import script from "./FlowConfig01List.vue?vue&type=script&lang=js&"
export * from "./FlowConfig01List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd366a7",
  null
  
)

export default component.exports